import { createSlice } from "@reduxjs/toolkit";


const initialState = [];

const dietSlice = createSlice({
    name:'diet',
    initialState,
    reducers:{}
})

export const {} = dietSlice.actions;
export default dietSlice.reducer;